export default __webpack_public_path__ + "static/media/Bridge_Partner resize.6a6f121c.jpg";